export default __webpack_public_path__ + "static/media/sent.6a705269.svg";